import { render } from "./BidEdit.vue?vue&type=template&id=5987b061"
import script from "./BidEdit.vue?vue&type=script&lang=js"
export * from "./BidEdit.vue?vue&type=script&lang=js"

import "./BidEdit.vue?vue&type=style&index=0&id=5987b061&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__